import getHelper from '../../../services/getHelper';

export default getHelper('/saml/:id', {
  authenticationRequest: getHelper('/authentication-request/:id'),
});
